import { ControlInterface } from 'edocatbase/Form';
import { isEmpty } from 'ramda';
import { hasValueChanged, defineValueToSend, getValue } from '../../../lib/authority';
import Value from './Value';

const Select = window.Edocat.Components.Select.Authority;

import { getNamesByNodes } from '../../../actions/form';
import { Dispatch } from 'redux';
import { ReduxComponentInterface } from 'edocatbase/Global';

interface AuthorityInterface extends ControlInterface, ReduxComponentInterface {
	formInstanceId: string;
	innerFormInstanceId?: string;
	readOnly: boolean;
	helperText: string;
	important: any;
}

class Authority extends window.React.PureComponent<AuthorityInterface> {
	static defaultProps = {
		excludedOptions: [],
		disableNodeRef: [],
	};

	updateValue = () => {
		const { actions, name, value, defaultValue, formInstanceId, innerFormInstanceId } = this.props;

		if ((value && !isEmpty(value)) && !value[0].displayName) {
			if (value === 'currentUser' || value[0] === 'currentUser') {
				const currentUser = window.Alfresco.constants.CURRENT_USER;
				const currentUserValue = {
					value: currentUser.nodeRef,
					label: `${currentUser.firstName} ${currentUser.lastName} (${currentUser.userName})`,
					type: 'USER',
				};
				actions.getNamesByNodes(
					formInstanceId,
					name,
					defineValueToSend(currentUserValue, defaultValue),
					innerFormInstanceId
				);
			} else if (value === 'superior' || value[0] === 'superior') {
				const currentUser = window.Alfresco.constants.CURRENT_USER;
				const currentUserSuperiorValue = {
					value: currentUser.superior?.nodeRef,
					label: `${currentUser.superior?.firstName} ${currentUser.superior?.lastName} (${currentUser.superior?.userName})`,
					type: 'USER',
				};
				actions.getNamesByNodes(
					formInstanceId,
					name,
					defineValueToSend(currentUserSuperiorValue, defaultValue),
					innerFormInstanceId
				);
			} else {
				const values = typeof value === "string" ? value : Array.from(new Set(value));
				actions.getNamesByNodes(formInstanceId, name, defineValueToSend(values, defaultValue), innerFormInstanceId);
			}
		}
	};

	componentDidMount() {
		this.updateValue();
	}

	async componentDidUpdate(prevProps: any) {
		if (
			this.props.value &&
			((Array.isArray(this.props.value) && this.props.value.some(item => !item.hasOwnProperty('value'))) ||
				(!Array.isArray(this.props.value) && !this.props.value.hasOwnProperty('value'))) &&
			hasValueChanged(this.props.value, prevProps.value)
		) {
			await this.updateValue();
		}
	}

	onSelectChange = (value: any) => {
		const { name, onChange } = this.props;
		onChange([name], value, true);
	};

	render() {
		const {
			autoFocus,
			disabled,
			value,
			label,
			repeating,
			dataType,
			control: {
				params: { allowSystem, parentAuthority, root, disableExternalGroups, disableExternalUsers, disableNodeRef },
			},
			className,
			error,
			excludedOptions,
			mandatory,
			name,
			placeholder,
			readOnly,
			helperText,
			important,
		} = this.props;
		return readOnly ? (
			<div className={`form-row row-${name} simple-row`}>
				<label>{label}</label>
				<Value value={value} />
			</div>
		) : disabled ? (
			<div className={`form-row row-${name} read-only-row`}>
				<label>{label}</label>
				<Value value={value} />
			</div>
		) : (
			<div className={`form-row row-${name}`}>
				<Select
					id={name}
					allowSystem={allowSystem}
					disableExternalGroups={disableExternalGroups}
					disableExternalUsers={disableExternalUsers}
					autoFocus={autoFocus}
					className={className}
					disabled={disabled}
					error={error}
					excludedOptions={excludedOptions}
					disableNodeRef={disableNodeRef}
					isClearable={!mandatory}
					label={label}
					mandatory={mandatory}
					multi={repeating}
					name={name}
					onChange={this.onSelectChange}
					parentAuthority={parentAuthority}
					placeholder={placeholder}
					type={dataType}
					value={getValue(value, repeating)}
					helperText={helperText}
					important={important}
					root={root}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state: any, props: AuthorityInterface) => {
	const fieldNames = state[props.formInstanceId].form.fields[props.name]?.excludedOptionsFieldName;
	let selectedInOther:any = [];
	const excludedOptions = state[props.formInstanceId].form.fields[props.name]?.excludedOptions || [];
	fieldNames ? fieldNames.forEach(
		(item:any) => 
			Array.isArray(state[props.formInstanceId].form.fields[item]?.value) ?
				state[props.formInstanceId].form.fields[item]?.value.forEach(
					(item:any) => selectedInOther.push(item.value)
				)  : selectedInOther.push(state[props.formInstanceId].form.fields[item]?.value?.value)) : '';

	return {
		excludedOptions: selectedInOther,
		disableNodeRef: [...excludedOptions],
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: window.redux.bindActionCreators({ getNamesByNodes }, dispatch),
});

export default window.reactRedux.connect(mapStateToProps, mapDispatchToProps)(Authority);
